import { LogoContainer } from "./components/LogoContainer.js";
import { NotificationContainer } from "./components/NotificationContainer.js";
import { FooterContainer } from "./components/FooterContainer.js";
import { UtcInfoContainet } from "./components/UtcInfoContainet.js";
import { ProductContainer, ProductContainerData } from "./components/ProductContainer.js";

import css from "./styles.js";

export interface NotificationTemplateData {
  shop: string;
  logoHeader: string;
  logoFooter: string;
  notificationIcon: string;
  events: ProductContainerData[];
  stockType: string;
  actionType: string;
  createdAt: string;
  locationInfo?: string; // "All locations" or "Selected locations"
}

const NotificationTemplate = (data: NotificationTemplateData) => `
  <html>
    <head>
    <meta charset="utf-8">
    ${css}
    </head>
    <body style="font-family: sans-serif;">
      <div class="notification-template--wrapper">
        ${LogoContainer(data.logoHeader)}
        ${NotificationContainer(data.shop, data.notificationIcon, "Notification", data.createdAt, `${data.stockType}${data.locationInfo ? `<div style="font-size: 12px;margin-top: 8px;color: #666;font-weight:400;">Monitoring: ${data.locationInfo}</div>` : ''}`)}
        ${data.events.map((item) => ProductContainer(item, data.actionType)).join("")}
        ${UtcInfoContainet()}
      </div>
      ${FooterContainer(data.logoFooter, new Date().getFullYear())}
    </body>
  </html>
`;

export default NotificationTemplate;